import { useState } from 'react';
import { getErrorMessage } from '../utils/errors';

interface ConfirmRunModalProps {
  extractionName: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

/** Small confirmation popup before a manual extraction run (admin console). */
export function ConfirmRunModal({ extractionName, onConfirm, onClose }: ConfirmRunModalProps) {
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    setStarting(true);
    setError(null);
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      setError(getErrorMessage(err));
      setStarting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={starting ? undefined : onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <p className="confirm-run-message">
          Start a run of <strong>{extractionName}</strong> now?
        </p>
        {error && <div className="error-message">{error}</div>}
        <div className="modal-actions">
          <button type="button" className="btn-secondary" onClick={onClose} disabled={starting}>
            Cancel
          </button>
          <button type="button" className="btn-primary" onClick={confirm} disabled={starting} autoFocus>
            {starting ? 'Starting...' : 'Start'}
          </button>
        </div>
      </div>
    </div>
  );
}
